import { useMemo } from 'react';
import styles from './ChordVariantChips.module.css';

interface ChordVariantChipsProps {
  variantIds: string[];
  selectedId: string;
  onSelect: (id: string) => void;
}

export function ChordVariantChips({ variantIds, selectedId, onSelect }: ChordVariantChipsProps) {
  const uniqueIds = useMemo(() => Array.from(new Set(variantIds)), [variantIds]);
  if (uniqueIds.length === 0) return null;

  return (
    <div className={styles.row} role="group" aria-label="Chord variants">
      {uniqueIds.map((id) => {
        const selected = id === selectedId;
        return (
          <button
            type="button"
            key={id}
            onClick={() => onSelect(id)}
            className={[styles.chip, selected && styles.selected].filter(Boolean).join(' ')}
            aria-pressed={selected}
          >
            {id}
          </button>
        );
      })}
    </div>
  );
}
